export const checkIsMaintenanceMode = async () => {
  let response = await fetch(`${process.env.REACT_APP_API_URL}/maintenance-mode`);
  return response;
  // return {
  //   ...response,
  //   status: 200,  // FOR TESTING
  // };
};
